import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// eslint-disable-next-line import/prefer-default-export
export const toastMixin = {
  methods: {
    /**
     * Show toast notification
     * @param {Object} options - Toast options
     * @param {string} options.title - Toast title (required)
     * @param {string} [options.text] - Toast description text
     * @param {string} [options.variant='success'] - Toast variant: 'success', 'error', 'warning', 'info'
     */
    showToast({ title, text, variant = 'success' }) {
      const config = {
        success: { icon: 'CheckCircleIcon', toastVariant: 'success' },
        error: { icon: 'XCircleIcon', toastVariant: 'danger' },
        warning: { icon: 'AlertTriangleIcon', toastVariant: 'warning' },
        info: { icon: 'InfoIcon', toastVariant: 'info' },
      }

      const { icon, toastVariant } = config[variant] || config.success

      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon,
          variant: toastVariant,
        },
      })
    },

    // Shorthand methods
    toastSuccess(title, text) {
      this.showToast({ title, text, variant: 'success' })
    },
    toastError(title, text) {
      this.showToast({ title, text, variant: 'error' })
    },
    toastWarning(title, text) {
      this.showToast({ title, text, variant: 'warning' })
    },
    toastInfo(title, text) {
      this.showToast({ title, text, variant: 'info' })
    },
  },
}
